<template>
  <div class="parallax" :scrollTop="scrollPos">
    <slot />
  </div>
</template>

<style lang="scss">

</style>

<script>
export default {
  props:{
    factor: {
      default: 25
    },
  },
  data() {
    return {
      lastY: 0,
      isMobile: false
    };
  },
  methods: {
    resize(){
      if( window.innerWidth <= 768 ){
        this.isMobile = true
        this.$parallaxEl.style.transform = ''
      }else{
        this.isMobile = false
      }
    }
  },
  computed:{
    scrollPos: function(){
      let y = 0
      let scrollTop = this.$store.state.scrollTop

      if( this.$el ){
        this.box = this.$el.getBoundingClientRect()
        y = this.box.top
      }

      if( this.$parallaxEl ){
        y /= this.$store.state.innerWidth
        y *= -this.factor

        if( y < -this.factor ) y = -this.factor
        else if( y > this.factor ) y = this.factor

        if( this.lastY != y ){
          if( ! this.isMobile ) this.$parallaxEl.style.transform = 'translateY(' + y + '%)'
          this.lastY = y  
        }
      }
      
      return y
    }
  },
  mounted() {

    this.resizeHandler = ()=>this.resize()
    this.$parallaxEl = this.$el.firstChild

    this.resize()
    window.addEventListener('resize', this.resizeHandler )

  },
};
</script>
